import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "upload_body"
};
const _hoisted_2 = {
  class: "upload_body_nr"
};
const _hoisted_3 = {
  class: "upload_list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "img"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  style: {
    "margin-bottom": "20px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("h1", null, "案例分享", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $setup.go(item.id)
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
      src: item.caseTitleUrl,
      alt: ""
    }, null, 8, _hoisted_6)]), _createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_7, _toDisplayString(item.caseTitleName), 1), _createElementVNode("span", null, _toDisplayString(item.searchValue), 1)])])], 8, _hoisted_4);
  }), 128))])])]);
}